import { EuiSpacer } from '@elastic/eui';
import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { Auxiliar } from '../../../../../../infraestructure/persistence/rest/AuxiliaresAdapter';
import { Menu } from '../../../../components/Menus';
import { Action } from '../../../../components/Menus/interface';
import ModalApp from '../../../../components/Modal';
import FormularioAuxiliares from '../Formulario/container';
import { GridResultsScreen } from '../Grid/GridResultsScreen';
import { ActionType, CREATE, UPDATE } from './constants';
import ModalYesNo from '../../../../components/Modal/YesNo';

interface Props {
  data: any;
  handleCreate(data:Auxiliar):void;
  handleUpdate(oldData:any, newData:any):void;
  handleRemove(data:any):void;
}

export const AuxiliaresScreen = (props: Props) => {
  const ref:any = useRef();
  let { data, handleCreate, handleUpdate, handleRemove } = props;
  let [isModalVisible, setIsModalVisible] = useState(false);
  let [openRemoveModal, setOpenRemoveModal] = useState(false);
  let [selected, setSelected] = useState(undefined);
  let [actionType, setActionType] = useState<ActionType>(CREATE);

  const closeModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);

  useEffect(() => { closeModal(); setSelected(undefined); if(openRemoveModal){setOpenRemoveModal(false)}}, [data]);

  const prepareCreate = useCallback(() => {
    setActionType(CREATE);
    showModal();
  },[])

  const prepareEdit = useCallback(() => {
    setActionType(UPDATE);
    showModal();
  },[])

  const onCreate = useCallback((newData: any) => {
    if (newData && handleCreate) {
      handleCreate(newData)
    }
  },[handleCreate])

  const onUpdate = useCallback((newData: any) => {
    if (handleUpdate && (newData && selected)) {
      handleUpdate(selected,newData)
    }
  },[handleUpdate, selected])

  const onRemove = useCallback(() => {
    if (selected && handleRemove) {
      if(selected!==undefined){
        setOpenRemoveModal(true)
      }else{
        handleRemove(selected);
      }
    }
  },[selected, handleRemove])

  const onSelected = (selection: any) => {
    setSelected(selection[0])
  }

  const onExport = () =>{
    ref.current && ref.current.onExport();
  }

  const getSelected = useMemo(() =>{
    return actionType.tipo === "U" ? selected : undefined;
  },[actionType,selected])

  const getHandle = useCallback(() =>{
    if(actionType.tipo === "I"){
      return onCreate
    }else{
      return onUpdate
    }
  },[actionType,onCreate,onUpdate])

  const onConfirmRemove = (response:any) => {
    if(response!==undefined && response === true){
      handleRemove(selected);
    }else{
      setOpenRemoveModal(false)
    }
  }
  
  const Actions: Action[] = useMemo(()=>[
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false},
    {handle:onRemove,text:"Eliminar Selección",color:"danger",size:"s", isDisabled:(selected===undefined)},
    {handle:prepareEdit,text:"Editar Selección",color:"secondary",size:"s", isDisabled:(selected===undefined)},
    {handle:prepareCreate,text:"Nuevo Auxiliar",color:"primary",size:"s", isDisabled:false}
  ],[selected, prepareCreate, onRemove, onExport])


  const contentModal = useCallback(() =>  <FormularioAuxiliares handle={getHandle()} selected={getSelected} onClose={closeModal}/>,[getHandle,getSelected])
  const modal = useMemo(() => <ModalApp isOpen={isModalVisible} title={actionType.title} onClose={closeModal} content={contentModal()}/> ,[isModalVisible,actionType,contentModal])

  const getView = useMemo(() => {
    return (
      <>
        <Menu actions={Actions}/>
        <EuiSpacer size="s" />
        <GridResultsScreen
          data={data}
          onSelected={onSelected}
          selector={false}
          menu={false}
          ref={ref}
        />
        {modal}
        {openRemoveModal ? <ModalYesNo onClose={onConfirmRemove} isOpen={openRemoveModal}/> : null}
      </>
    )
  },[data, modal, onSelected, openRemoveModal, onConfirmRemove])

  return (
        <>
          {getView}
        </>
  );
};

export default AuxiliaresScreen;
